import { Component, inject, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-notification',
  standalone: false,
  styles: ``,
  templateUrl: './notification.component.html',
})
export class NotificationComponent implements OnInit {

  prompt: string = '';
  okBtnClass: string = 'btn-primary';
  okBtnText: string = `OK`;
  okBtnIcon: IconDefinition | null = null;

  private modal = inject(NgbActiveModal);

  ngOnInit(): void {
  }

  confirmModal(): void {
    this.modal.close();
  }

}

